<div
  class="autocomplete-select-container"
  [ngClass]="{ light: isLight, dark: !isLight }"
  appClickOutside
  (clickOutside)="handleClickOutside()"
>
  <div class="autocomplete-wrapper">
    <div class="input-container">
      <input
        type="text"
        [placeholder]="placeholder | translate"
        class="form-control autocomplete-input"
        [formControl]="searchControl"
        [id]="id"
        (focus)="onInputFocus()"
        [required]="required"
        [disabled]="disabled || inputLocked()"
        (keydown)="onInputKeydown($event)"
      />
      @if (selectedItem && !hideClear) {
        <button type="button" class="clear-btn" (click)="clearSelection()" [disabled]="disabled">&times;</button>
      }
    </div>

    <div class="autocomplete-icon-container" [ngClass]="showInvalid() ? 'd-flex' : 'd-none'">
      <app-icam-icon [iconName]="'info-error'" />
    </div>
  </div>

  @if (isDropdownOpen && !disabled) {
    <div class="dropdown">
      @if (isLoading) {
        <div class="loading">{{ 'COMMON.LOADING' | translate }}</div>
      }
      @if (errorMessage) {
        <div class="error">{{ errorMessage | translate }}</div>
      }
      @for (option of filteredOptions; track option) {
        <div
          class="dropdown-item"
          (click)="selectItem(option)"
          (keydown.enter)="selectItem(option)"
          tabindex="0"
          role="button"
          [class.active]="selectedItem && option[valueField] === selectedItem[valueField]"
        >
          <small>
            {{ option[displayField] | translate }}
          </small>
        </div>
      }
      @if (!isLoading && filteredOptions.length === 0 && searchControl.value) {
        <div class="no-results">
          {{ 'COMMON.NO_RESULTS_FOUND' | translate }}
        </div>
      }
    </div>
  }
</div>
